"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Vue, Component, PropSync } from "vue-property-decorator";
import { Debounce } from "vue-debounce-decorator";
import API from "@ym-framework/api-utils";
let ColumnRenew = class extends Vue {
  mounted() {
  }
  change(change) {
    return __async(this, null, function* () {
      try {
        if (this._column.expire_in_seconds <= 3600 * 72 && this._column.modelResource.autoRenew) {
          yield this.$alert(
            this.$t("vdcontainer.currently_selected_tip").toString(),
            this.$t("vdcontainer.currently_selected").toString(),
            {
              confirmButtonText: this.$t("vdcontainer.i_know").toString()
            }
          );
          this._column.modelResource.autoRenew = false;
        } else {
          if (this._column.modelResource.autoRenew === true) {
            let arr = [this._column.id];
            yield API.post(`api://base.auth.pro/v1/virtual-desktops-auto-renew`, {
              "ids": arr
            });
          } else {
            let arr = [this._column.id];
            yield API.delete(`api://base.auth.pro/v1/virtual-desktops-auto-renew`, {
              data: {
                "ids": arr
              }
            });
          }
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  PropSync("column")
], ColumnRenew.prototype, "_column", 2);
__decorateClass([
  Debounce(800)
], ColumnRenew.prototype, "change", 1);
ColumnRenew = __decorateClass([
  Component({})
], ColumnRenew);
export {
  ColumnRenew as default
};
